/**
 * Module dependencies.
 */

import * as React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from 'app/lib/utils';

/**
 * `SpinnerProps` type.
 */

type SpinnerProps = {
  className?: string;
};

/**
 * Export `Spinner` component.
 */

export function Spinner({ className }: SpinnerProps): JSX.Element {
  return (
    <Loader2 aria-label={'Loading'} className={cn('h-8 w-8 animate-spin text-primary', className)} role={'status'} />
  );
}

/**
 * Export `SpinnerOverlay` — a centered spinner filling its container.
 */

export function SpinnerOverlay({ className }: SpinnerProps): JSX.Element {
  return (
    <div className={cn('flex min-h-[150px] w-full items-center justify-center', className)}>
      <Spinner className={'h-10 w-10'} />
    </div>
  );
}
